import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorDialogData } from '@interfaces';

@Component({
  selector: 'frontend-workspace-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ErrorComponent implements OnInit {
  data = inject<ErrorDialogData>(MAT_DIALOG_DATA);

  description: string | undefined;

  ngOnInit(): void {
    this.description = this.data.description || this.description;
  }
}
